import styled, { css } from "styled-components";
export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 10rem 5rem 0 35rem;

    @media (min-width: 1600px) {
      margin: 8rem 5rem 0 35rem;
    }
    /* posição navegação */
    @media only screen and (max-width: 480px) {
      margin: 0 1rem 0 1rem;
    }
    @media only screen and (max-width: 978px) {
      margin: 0 1rem 0 1rem;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding-bottom: 1rem;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 998px) {
      margin-top: 8rem;
    }
  `}
`;

export const BoxUser = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;

    ${Description} {
      color: ${theme.colors.gray};
      font-style: normal;
    }

    @media (min-width: 1600px) {
      margin-top: 1.8rem;
      ${Description} {
        font-size: ${theme.font.sizes.medium};
      }
    }
  `}
`;

export const AddNew = styled.div`
  ${({ theme }) => css`
    margin-right: -10px;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: ${theme.colors.lineBlue};
    font-size: ${theme.font.sizes.xlarge};
    p {
      font-size: 18px;
      display: block ruby;
    }
  `}
`;

export const Image = styled.img`
  ${({ theme }) => css`
    margin-right: 1.5rem;
    height: 3rem;
    color: ${theme.colors.lineBlue};

    @media (min-width: 1600px) {
      height: 4rem;
    }

    @media only screen and (max-width: 500px) {
      height: 2.8rem;
      margin-left: 2.2rem;
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    font-weight: bold;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.large};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    line-height: 1.2;
  `}
  @media only screen and (max-width: 500px) {
    font-size: 1.3rem;
  }
`;

export const Content = styled.div`
  max-width: 70%;
  margin: 0 auto;
  margin-top: 4rem;

  @media (max-width: 768px) {
    max-width: 90%;
  }

  @media (min-width: 768px) {
    max-width: 58%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 6rem;

  > button {
    margin-left: 1.8rem;
  }

  @media (max-width: 1600px) {
    /* margin-top: 5rem; */
    margin-bottom: 11px;
    margin-top: 6rem;
    flex-wrap: inherit;
  }

  @media (min-width: 1600px) {
    flex-wrap: inherit;
  }
`;

export const ButtonExclude = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 50%;

  ${({ theme }) => css`
    .inativar {
      background-color: white;
      border: 1px solid ${theme.colors.lineBlue};
      color: ${theme.colors.lineBlue};
    }

    .inativo {
      background-color: white;
      border: 1px solid red;
      color: red;
      pointer-events: none;
    }
  `}
`;

export const InputBox = styled.div`
  ${({ columns = "2fr 1fr", gap = "2rem" }) => css`
    display: grid;
    grid-template-columns: ${columns};
    gap: ${gap};
    width: 90%;
    margin-top: 5px;
  `}
`;

export const TextAreaBox = styled.div`
  ${({ theme }) => css`
    width: 90%;
  `}
`;

export const InputRadioBox = styled.div`
  ${({ columns = "2fr 1fr", gap = "2rem" }) => css`
    display: flex;
    gap: ${gap};
    width: 90%;
    margin-top: 20px;
  `}
`;

export const InputRadio = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.xlarge};
    margin-top: 2rem;
    font-weight: 500;

    p {
      font-size: ${theme.font.sizes.medium};
      display: flex;
      align-items: center;

      @media only screen and (max-width: 500px) {
          font-size: ${theme.font.sizes.medium};
        }
    }

    .boxradio {
      /* margin: 0 90px; */
      display: flex;
      align-items: center;
    }

    label {
      font-size: ${theme.font.sizes.medium};
      position: relative;
      bottom: 0.3rem;
      margin-right: 30px;
      @media (max-width: 1565px) {
        font-size: 15px;
      }

      @media only screen and (max-width: 500px) {
        display: flex;
        align-items: center;
     }
    }

    @media (min-width: 1600px) {
      p {
        font-size: 1.7rem;
        display: flex;
        align-items: center;
      }
      }
    }

    .radio {
      position: relative;
      top: 0.2rem;
      margin-left: 1.8rem;
      margin-right: 5px;
      width: 2rem;
      height: 2rem;
      color: gray;
    }
  `}
`;

export const SubTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    margin-top: 4rem;
    display: flex;
    flex-direction: column;
    font-family: Roboto;
    font-weight: 500;

    &::after {
      content: "";
      display: block;
      width: 90%;
      height: 0.3rem;
      border-bottom: 2px solid #a1a1a1;

      margin-top: 1.6rem;
    }

    @media (min-width: 1600px) {
      font-size: 2rem;
      margin-top: 6rem;
    }
  `}
`;
